<template>
  <main-layout>
    <div v-if="!(this.powerListCheck(this.allPower).allPowerCheck)">
      <el-alert
        title="您无权查看本页面。"
        type="warning"
        show-icon
        :closable="false"
      />
    </div>
    <div
      class="pages"
      v-loading="loading"
      v-if="this.powerCheck('获取问答活动列表')"
    >
      <el-card class="box-card">
        <div class="faq_ctrlCol">
          <div class="faq_searchCol">
            <div class="faq_searchCol_input">
              <el-input
                v-model="searchText"
                placeholder="请输入搜索内容"
                size="small"
              ></el-input>
            </div>
            <div class="faq_searchCol_button">
              <el-button
                type="primary"
                size="small"
                @click="this.getData"
              >搜索</el-button>
            </div>
          </div>
          <div class="faq_functionCol">
            <div class="faq_searchCol_button">
              <el-button
                type="primary"
                size="small"
                @click="this.addVisible = true"
                v-if="this.powerCheck('添加问答活动')"
              >新增问答</el-button>
            </div>
          </div>
        </div>
        <div class="faq_table">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              label=" "
              width="80"
            >
              <template #default="scope">
                <span style="margin-left: 10px">{{ ((this.pageNum - 1) * this.pageSize) + (scope.$index + 1) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="问答名称"
            />
            <el-table-column
              prop="target"
              label="目标人数"
            />
            <el-table-column
              prop="joinVolunteerCount"
              label="参与人数"
              sortable
            />
            <!-- <el-table-column
              prop="address"
              label="使用证书"
            /> -->
            <el-table-column label="开始日期">
              <template #default="scope">
                {{ moment(scope.row.startTime*1000).format('YYYY-MM-DD') }}
                <br />
                {{ moment(scope.row.startTime*1000).format('HH:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column label="结束日期">
              <template #default="scope">
                {{ moment(scope.row.endTime*1000).format('YYYY-MM-DD') }}
                <br />
                {{ moment(scope.row.endTime*1000).format('HH:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              width="320px"
            >
              <template #default="scope">
                <el-button
                  type="success"
                  size="small"
                  @click="this.creatURL(scope.row.id)"
                >生成链接</el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="this.startEdit(scope.row.id)"
                  v-if="this.powerCheck('编辑问答活动详情')"
                >编辑</el-button>

                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  icon="el-icon-info"
                  iconColor="red"
                  title="确定删除吗？"
                  @confirm="this.delete(scope.row.id)"
                >
                  <template #reference>
                    <el-button
                      type="danger"
                      size="small"
                      v-if="this.powerCheck('删除问答活动')"
                    >删除</el-button>
                  </template>
                </el-popconfirm>
                <el-button
                  type="primary"
                  size="small"
                  @click="this.exportData(scope.row.id)"
                  v-if="this.powerCheck('导出问答活动数据')"
                >导出</el-button>
                <!-- <el-button
                  type="primary"
                  size="small"
                >结算（未实现）</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="this.sizeChange"
            @current-change="this.pageChange"
            :current-page="this.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="this.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="this.total"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
    <AddFAQ
      :isVisible="this.addVisible"
      @closeAct="this.closeAdd"
      @addSuccess="this.addSuccess"
    />
    <EditFAQ
      :isVisible="this.editVisible"
      :editFAQID="this.editCertificateID"
      @closeAct="this.closeEdit"
      @editSuccess="this.editSuccess"
    />
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/Main.vue";
import AddFAQ from "./addFAQ.vue";
import EditFAQ from "./editFAQ.vue";
import { powerCheck, powerListCheck } from "@/tools/util";
import { ax } from "@/service/http";
import moment from "moment";
import { ElMessage } from "element-plus";
import QRCode from "qrcode";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      total: 1,
      loading: false,
      allPower: ["获取问答活动列表"],
      tableData: [],
      addVisible: false,
      editVisible: false,
      editCertificateID: 0,
      searchText: "",
    };
  },
  loading: false,
  components: {
    MainLayout,
    AddFAQ,
    EditFAQ,
  },
  created() {
    this.getData();
    // this.getQiniuToken();
  },
  methods: {
    powerCheck,
    powerListCheck,
    moment,
    creatURL(id) {
      let urlWord = `https://wx.fryj.top/questionarticle/${id}`;
      QRCode.toDataURL(urlWord)
        .then((url) => {
          this.$alert(
            `
              <div>${urlWord}</div>
              <div>
                <img src="${url}">
              </div>
            `,
            "URL链接",
            {
              confirmButtonText: "确定",
              dangerouslyUseHTMLString: true,
            }
          );
        })
        .catch((err) => {
          console.error(err);
        });
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    pageChange(e) {
      this.pageNum = e;
      this.getData();
    },
    closeAdd() {
      this.addVisible = false;
    },
    addSuccess(newData) {
      console.log(newData);
      this.addVisible = false;
      this.tableData = [...this.tableData, newData];
    },
    startEdit(idx) {
      this.$confirm(
        "此操作修改问答题目将会导致答题记录被清除，请谨慎操作！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.editCertificateID = idx;
        this.editVisible = true;
      });
    },
    closeEdit() {
      this.editVisible = false;
    },
    delete(id) {
      ax("delFAQ", { urlParam: { id } })
        .then(() => {
          let newTableData = [];
          for (let i in this.tableData) {
            if (id != this.tableData[i].id)
              newTableData.push(this.tableData[i]);
          }
          this.tableData = newTableData;
          ElMessage.success({
            message: "问答活动已删除",
            type: "success",
          });
        })
        .catch((e) => {
          ElMessage.error({
            message: e.msg,
            type: "error",
          });
        });
    },
    editSuccess(newData) {
      console.log(newData);
      let newTableData = [...this.tableData];
      for (let i in newTableData) {
        if (newData.id == newTableData[i].id) newTableData[i] = newData;
      }
      this.tableData = newTableData;
      this.editVisible = false;
    },
    getData() {
      // console.log(e)
      this.loading = true;
      let queryObject = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      console.log(queryObject);
      if (this.searchText != "") {
        queryObject.searchText = this.searchText;
      }
      ax("getFAQList", { data: queryObject })
        .then((res) => {
          console.log(res);
          if (!res.data.list) res.data.list = [];
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportData(id) {
      ax("exportFAQ", { urlParam: { id: id }, typeFile: true })
        .then((res) => {
          console.log(res);
          // if (!res.data.list) res.data.list = [];
          // this.tableData = res.data.list;
          // this.total = res.data.total;
          // this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less">
.faq_ctrlCol {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.faq_chooseSchool,
.faq_searchCol {
  flex: 2;
}
.faq_searchCol {
  display: flex;
  align-items: center;
}
.faq_searchCol_input {
  width: 200px;
}
.faq_searchCol_button {
  flex: 1;
  padding-left: 10px;
}
.faq_functionCol {
  flex: 2;
  text-align: right;
}
.faq_table {
}
</style>
